import type { EditorState } from '@tiptap/pm/state'

export const getCharAround = (state: EditorState, from: number, to: number, isBefore?: boolean) => {
  const pos = isBefore ? from - 1 : to
  return state.doc.textBetween(pos, pos + 1) // same (from - 1, from) or (to, to + 1)
}
